import { render } from "./LayoutFull.vue?vue&type=template&id=71f2af4c"
import script from "./LayoutFull.vue?vue&type=script&lang=js"
export * from "./LayoutFull.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__